<script>
import ProductGroup from 'sales-flow-ui/components/ProductGroup';
import find from 'lodash/find';
import filter from 'lodash/filter';
import { mapState } from 'vuex';

import config from 'config';
import HomeHeader from './HomeHeader';
import JoinNowBanner from './HomeJoinNowBanner';
import ShopByCategory from './HomeShopByCategory';
import Collection from './HomeCollection';
import EmailOffers from './HomeEmailOffers';
import HomeFooter from './HomeFooter';
import HomeCurated from './HomeCurated';

export default {
  components: {
    ProductGroup,
    HomeHeader,
    JoinNowBanner,
    ShopByCategory,
    Collection,
    EmailOffers,
    HomeFooter,
    HomeCurated,
  },
  data: () => ({
    config,
  }),
  computed: {
    ...mapState({
      currencyInfo: state => state.currencyInfo,
      featuredCampaigns: state => state.home.featuredCampaigns,
      hobbiesCampaigns: state => state.home.hobbiesCampaigns,
      occupationsCampaigns: state => state.home.occupationsCampaigns,
      categories: state => state.marketplace.categories,
    }),
    hobbiesCategory() {
      return this.categories ? find(this.categories.parent, category => category.category === 'Hobbies') : {};
    },
    jobsCategory() {
      return this.categories ? find(this.categories.parent, category => category.category === 'Occupations') : {};
    },
    hobbyLinks() {
      return this.categories ? filter(this.categories.sub, category => category.parent === 'Hobbies').slice(0, 5) : null;
    },
    jobsLinks() {
      return this.categories ? filter(this.categories.sub, category => category.parent === 'Occupations').slice(0, 5) : null;
    },
  },
  watch: {
    categories(categories) {
      if (categories) {
        this.$store.dispatch('getHomepageCampaigns', this.hobbiesCategory);

        this.$store.dispatch('getHomepageCampaigns', this.jobsCategory);
      }
    },
  },
  created() {
    this.$store.dispatch('getFeaturedCampaigns');
  },
  metaInfo() {
    let meta = [],
      title = 'Viralstyle';

    meta.push({ property: 'fb:app_id', content: config.ENVIRONMENT === 'Production' ? 153455978162908 : 'development' });

    meta.push({ property: 'og:url', content: `${config.APP_PROTOCOL}://${config.ENVIRONMENT === 'Production' ? window.location.hostname : config.APP_URL}` });

    meta.push({ property: 'og:type', content: 'website' });

    meta.push({ property: 'og:title', content: 'Viralstyle' });

    meta.push({ property: 'og:image', content: 'https://s3.amazonaws.com/viral-tees/og-homepage.png' });

    meta.push({ property: 'og:description', content: 'Viralstyle Is the 100% Free Way to Sell High-quality T-shirts.' });

    return {
      title,
      meta,
    };
  },
};
</script>

<template lang='pug'>
.home
  home-header
  //- featured products
  product-group.mt-3.container.mx-auto.lg_mt-4.xl_mt-5(
    v-if='featuredCampaigns.length',
    text='featured',
    utm-source='featured',
    :affiliate='config.AFFILIATE_ID',
    :campaigns='featuredCampaigns',
    :currency-info='currencyInfo',
  )
  home-curated
  collection(
    utm-source='homepage-hobbies',
    :category='hobbiesCategory',
    :links='hobbyLinks',
    :campaigns='hobbiesCampaigns',
  )
  join-now-banner
  shop-by-category
  collection(
    utm-source='homepage-occupation',
    :category='jobsCategory',
    :links='jobsLinks',
    :campaigns='occupationsCampaigns',
  )
  //- email-offers
  home-footer
</template>

<style>
@import '~import/index';
</style>